<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="distributionUsersSelected"
    :clearable="!unclearable"
    :items="distributionUsersItems"
    :loading="distributionUsersLoading"
    :search-input.sync="distributionUsersSearch"
    item-text="name"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('DistributionUser.ObjectName')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import DistributionUsers from "@/api/distribution_users";

export default {
  name: "SearcherDistributionUser",

  props: {
    value: Object,
    stockId: [Number, Array ],
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    mustStockId: Boolean,
  },

  computed: {
    distributionUsersItems() {
      return this.distributionUsers.map((distributionUser) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == distributionUser.id
            )
          : false;
        return Object.assign({}, distributionUser, { disabled });
      });
    },
  },

  data: () => ({
    distributionUsers: [],
    distributionUsersLoading: false,
    distributionUsersSearch: "",
    distributionUsersSelected: null,
  }),

  methods: {
    getDistributionUsersFromAPI() {
      if (this.mustStockId && (!this.stockId || this.stockId.length < 1)) {
        return;
      }
      this.distributionUsersLoading = true;
      DistributionUsers.fetchAllForSelect({ stock_id: this.stockId })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.distributionUsers = response.data.distributionUsers;
            }
            this.distributionUsersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.distributionUsersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.distributionUsersSelected = this.value;
      },
    },
    stockId: {
      handler() {
        this.distributionUsers = [];
        this.getDistributionUsersFromAPI();
      },
    },
    distributionUsersSelected: {
      handler() {
        this.$emit("input", this.distributionUsersSelected);
      },
    },
    distributionUsersSearch: {
      immediate: true, //初始赋值也调用
      handler() {
        if (
          this.distributionUsersSelected &&
          this.distributionUsersSearch ==
            this.distributionUsersSelected.code +
              " / " +
              this.distributionUsersSelected.name
        )
          return; // 查询结果一致的话不再执行

        this.getDistributionUsersFromAPI();
      },
    },
  },
};
</script>